import { Bars3BottomLeftIcon } from '@heroicons/react/24/outline';
import React, { ReactNode } from 'react';
import { openMenu } from '../../state/app-state';
import { classNames } from '../../utils/class-names';

interface DashboardNavProps {
  className?: string;
  children: ReactNode;
}

const DashboardNav: React.FC<DashboardNavProps> = ({ className, children }) => {
  return (
    <div
      className={classNames(
        className ? className : '',
        'relative shrink-0 flex h-12 bg-white border-b border-gray-200'
      )}
    >
      <button
        type="button"
        className="h-12 w-12 flex items-center justify-center text-gray-500 focus:outline-hidden md:hidden"
        onClick={() => openMenu()}
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
      </button>

      <div className="flex-1 flex pl-2 md:pl-4 pr-4 justify-between items-center">{children}</div>
    </div>
  );
};

export default DashboardNav;
